import type { LinkProps } from './Link'
import Link from './Link'
export type { LinkProps }
export { docTypeSwitch } from './Link'
export default Link
